/*eslint-disable */
import {mapGetters, mapState} from 'vuex';
var $ = window.jQuery = require('jquery');
export default {
  name: 'assignment-solutionlist',
  components: {},
  props: [],
  data () {
    return {
     assignmentSolution: {},
      accordionVal: 0,
    empty: false,
    }
  },
  computed: {
    ...mapGetters([
      'singleAssignment'
    ]),
    ...mapState([
      'singleAssignmentState'
    ]),
    getAssignmentSolution(){
     return  this.assignmentSolution = this.$store.state.assignmentStore.singleAssignmentState.solution
    }
  },
  mounted () {
    this.getAssignmentSolution
   
  },
  methods: {
    toggleAccordion(id){
      let accordionContent = '#assignmentSolution' + id;
      let accordiontitle = '#assignmentSolutionTitle' + id;
      $(accordionContent).toggleClass('show');
      $(accordiontitle).toggleClass('active')
    },
    
  },
  watch: {
    getAssignmentSolution(){
      return  this.$store.state.assignmentStore.singleAssignmentState.solution
    },

    assignmentSolution: function () {
      empty= $.isEmptyObject(assignmentSolution)
    }
    
  }
}
